import { logger } from '@/services/logger/logger.client'
import { type ErrorResponse, onError } from '@apollo/client/link/error'

export const errorLink = onError((error: ErrorResponse) => {
  if (error.graphQLErrors) {
    error.graphQLErrors.forEach(({ message, locations, path }) => {
      logger.warn(`GraphQL error in ${error.operation.operationName}: ${message}`, {
        operationName: error.operation.operationName,
        message,
        locations,
        path,
      })
    })
  }
  if (error.networkError) {
    logger.error(`Network error in ${error.operation.operationName}`, {
      operationName: error.operation.operationName,
      error: error.networkError,
    })
  }
})
